const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight-car" */ '@/pages/financial/tariff/freight/car/index.vue'
  )

const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight-car" */ '@/pages/financial/tariff/freight/car/create.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-freight-car" */ '@/pages/financial/tariff/freight/car/edit.vue'
  )

export default {
  name: 'FinancialFreightCarTariff',
  path: 'car',
  meta: {
    label: 'car',
    auth: 'car'
  },
  component: {
    name: 'Car',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffFreightCarReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateTariffFreightCar',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTariffFreightCar',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
